module.exports = __webpack_public_path__ + "img/reihen.ef4ffc7f.jpg";